import React from 'react';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import './SobreNosotrosPage.css';

const SobreNosotrosPage = ({ darkMode, toggleDarkMode }) => {
  const valores = [
    {
      titulo: 'Enfoque en Resultados',
      descripcion: 'Nos centramos en entregar soluciones que generen valor real y medible para nuestros clientes.'
    },
    {
      titulo: 'Colaboración Cercana',
      descripcion: 'Trabajamos como un equipo más de tu empresa, entendiendo tus necesidades y objetivos.'
    },
    {
      titulo: 'Innovación Constante',
      descripcion: 'Siempre al día con las últimas tecnologías para ofrecer las mejores soluciones.'
    }
  ];

  const areasEquipo = [
    { id: 'direccion', titulo: 'Dirección' },
    { id: 'administracion', titulo: 'Administración' },
    { id: 'comercial', titulo: 'Comercial' },
    { id: 'it', titulo: 'IT' },
  ];

  const equipo = [
    {
      nombre: 'David Ramallo',
      cargo: 'Director y cofundador',
      descripcion:
        'Líder con experiencia en transformación digital y gestión estratégica de proyectos tecnológicos.',
      especialidad: 'Estrategia digital',
      area: 'direccion',
    },
    {
      nombre: 'Helena González',
      cargo: 'Cofundadora',
      descripcion:
        'Cofundadora de E-ASY y coordinación operativa de proyectos: que lo acordado avance, se alinee y llegue a cerrarse.',
      especialidad: 'Estrategia operativa',
      area: 'direccion',
    },
    {
      nombre: 'Aizbeltz Buiza',
      cargo: 'Responsable de Administración y Proyectos',
      descripcion:
        'Coordina la operativa interna y el pulso de los proyectos: plazos, facturación y que lo acordado se cierre sin cabos sueltos.',
      especialidad: 'Administración y proyectos',
      area: 'administracion',
    },
    {
      nombre: 'Ángel Cordero',
      cargo: 'Contabilidad y Proyectos',
      descripcion:
        'Lleva la contabilidad y el seguimiento económico de los proyectos. Números claros para saber dónde está cada cosa.',
      especialidad: 'Contabilidad',
      area: 'administracion',
    },
    {
      nombre: 'Cristhian Santa',
      cargo: 'Éxito del cliente',
      descripcion:
        'Acompaña la relación después de la venta: que el producto se use, que las incidencias no queden en el limbo y que el cliente no se quede solo en producción.',
      especialidad: 'Éxito del cliente',
      area: 'comercial',
    },
    {
      nombre: 'Nuhacet García',
      cargo: 'Consultor comercial',
      descripcion:
        'Primera conversación y encaje del caso. Traduce lo que duele en una propuesta que se puede ejecutar.',
      especialidad: 'Consultoría comercial',
      area: 'comercial',
    },
    {
      nombre: 'Lisania Mendoza',
      cargo: 'Diseñadora gráfica',
      descripcion:
        'Identidad, piezas y materiales de la marca: de la web al documento que el cliente ve. Claridad visual, no adorno.',
      especialidad: 'Diseño gráfico',
      area: 'comercial',
    },
    {
      nombre: 'Noelia Ibañez',
      cargo: 'Ingeniera de Software',
      descripcion:
        'Diseña y construye el software que operamos: backends, producto y lo que tiene que aguantar el día a día, no un prototipo.',
      especialidad: 'Ingeniería de software',
      area: 'it',
    },
    {
      nombre: 'Adrián García',
      cargo: 'Ingeniero de Software',
      descripcion:
        'Desarrollo de producto y sistemas. Código que se puede mantener, desplegar y explicar al resto del equipo.',
      especialidad: 'Ingeniería de software',
      area: 'it',
    },
    {
      nombre: 'Roberto Padrón',
      cargo: 'Ingeniero de Software',
      descripcion:
        'Ingeniería aplicada a los proyectos del estudio: de la lógica de negocio a dejarlo funcionando en producción.',
      especialidad: 'Ingeniería de software',
      area: 'it',
    },
    {
      nombre: 'Sergio Fernández',
      cargo: 'Desarrollador web',
      descripcion:
        'Especialista en desarrollo web: interfaces claras y experiencias que el usuario entiende a la primera.',
      especialidad: 'Desarrollo web',
      area: 'it',
    },
    {
      nombre: 'Airam Guadalupe',
      cargo: 'Desarrollador web',
      descripcion:
        'Desarrollo web y front: páginas, flujos y detalle de interfaz para que el producto se use de verdad.',
      especialidad: 'Desarrollo web',
      area: 'it',
    },
    {
      nombre: 'Jonay Armas',
      cargo: 'Desarrollador web',
      descripcion:
        'Implementa y evoluciona las webs del estudio: rendimiento, accesibilidad y un resultado que se puede publicar.',
      especialidad: 'Desarrollo web',
      area: 'it',
    },
  ];

  const historia = [
    {
      año: '2020',
      titulo: 'Fundación',
      descripcion: 'Nacimos con la visión de democratizar la tecnología para las empresas.'
    },
    {
      año: '2022',
      titulo: 'Primera Expansión',
      descripcion: 'Crecimos nuestro equipo y atendimos a más de 20 clientes.'
    },
    {
      año: '2023',
      titulo: 'Transformación Digital',
      descripcion: 'Nos especializamos en soluciones cloud y automatización.'
    },
    {
      año: '2025',
      titulo: 'Referencia en el Sector',
      descripcion: 'Más de 60 proyectos exitosos y presencia en múltiples sectores.'
    }
  ];

  return (
    <>
      <SEO 
        title="Sobre Nosotros | Consultoría Tecnológica en Tenerife | E-ASY"
        description="Conoce E-ASY: +5 años transformando PYMEs canarias con tecnología. Equipo experto en consultoría tecnológica, IA, desarrollo de software y digitalización en Santa Cruz de Tenerife."
        keywords="equipo E-ASY Tenerife, consultores tecnológicos Canarias, empresa tecnología Santa Cruz, historia E-ASY, valores empresa tecnología"
        canonical="https://e-asy.es/sobre-nosotros"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`sobre-nosotros-page ${darkMode ? 'dark' : 'light'}`}>
        {/* Hero Section */}
        <section className="sobre-nosotros-hero">
          <div className="sobre-nosotros-hero-content">
            <div className="sobre-nosotros-hero-text">
              <h1 className="sobre-nosotros-hero-title">Sobre E-ASY</h1>
              <p className="sobre-nosotros-hero-subtitle">
                5 años transformando empresas con tecnología. Somos tu partner tecnológico de confianza, especializados en consultoría, desarrollo de software y digitalización empresarial.
              </p>
              <div className="sobre-nosotros-hero-stats">
                <div className="hero-stat">
                  <div className="hero-stat-number">5+</div>
                  <div className="hero-stat-label">años de experiencia</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">60+</div>
                  <div className="hero-stat-label">proyectos exitosos</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">95%</div>
                  <div className="hero-stat-label">satisfacción cliente</div>
                </div>
              </div>
            </div>
            <div className="sobre-nosotros-hero-video">
              <div className="sobre-nosotros-hero-visual">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="sobre-nosotros-hero-video"
                >
                  <source src="/videos/hero-about-us-v1.mp4" type="video/mp4" />
                  <source src="/videos/hero-about-us-v1.webm" type="video/webm" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
            </div>
          </div>
        </section>

      {/* Misión y Visión */}
      <section className="mision-vision-section">
        <div className="mision-vision-content">
          <div className="mision-card">
            <div className="mision-icon">⚡</div>
            <h3 className="mision-title">Nuestra Misión</h3>
            <p className="mision-description">
              Democratizar la tecnología para que todas las empresas, sin importar su tamaño, 
              puedan acceder a soluciones digitales de alta calidad que impulsen su crecimiento.
            </p>
          </div>
          <div className="vision-card">
            <div className="vision-icon">🚀</div>
            <h3 className="vision-title">Nuestra Visión</h3>
            <p className="vision-description">
              Ser el partner tecnológico de confianza para empresas que buscan transformarse 
              digitalmente, siendo reconocidos por nuestra innovación y compromiso con el éxito.
            </p>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="valores-section">
        <div className="valores-content">
          <div className="valores-header">
            <h2 className="valores-title">Nuestros Valores</h2>
            <p className="valores-subtitle">
              Los principios que guían nuestro trabajo y relación con los clientes
            </p>
          </div>
          <div className="valores-grid">
            {valores.map((valor, index) => (
              <div key={index} className="valor-card">
                <h3 className="valor-title">{valor.titulo}</h3>
                <p className="valor-description">{valor.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Historia */}
      <section className="historia-section">
        <div className="historia-content">
          <div className="historia-header">
            <h2 className="historia-title">Nuestra Historia</h2>
            <p className="historia-subtitle">
              Un viaje de 5 años transformando empresas con tecnología
            </p>
          </div>
          <div className="historia-timeline">
            {historia.map((evento, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-year">{evento.año}</div>
                <div className="timeline-content">
                  <h3 className="timeline-title">{evento.titulo}</h3>
                  <p className="timeline-description">{evento.descripcion}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipo */}
      <section className="equipo-section">
        <div className="equipo-content">
          <div className="equipo-header">
            <h2 className="equipo-title">Nuestro equipo</h2>
            <p className="equipo-subtitle">
              Dirección, administración, comercial e IT. El mismo criterio: entregar y operar, no dejar un prototipo.
            </p>
          </div>
          {areasEquipo.map((area) => {
            const miembros = equipo.filter((miembro) => miembro.area === area.id);
            return (
              <div key={area.id} className="equipo-area">
                <h3 className="equipo-area-title">{area.titulo}</h3>
                <div className="equipo-grid">
                  {miembros.map((miembro) => (
                    <article key={miembro.nombre} className="miembro-card">
                      <div className="miembro-avatar">
                        <div className="avatar-placeholder" aria-hidden="true">
                          {miembro.nombre
                            .split(' ')
                            .filter(Boolean)
                            .slice(0, 2)
                            .map((parte) => parte[0])
                            .join('')}
                        </div>
                      </div>
                      <h4 className="miembro-nombre">{miembro.nombre}</h4>
                      <p className="miembro-cargo">{miembro.cargo}</p>
                      <p className="miembro-descripcion">{miembro.descripcion}</p>
                      <div className="miembro-especialidad">
                        <span className="especialidad-tag">{miembro.especialidad}</span>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="sobre-nosotros-cta-section">
        <div className="sobre-nosotros-cta-content">
          <h2 className="sobre-nosotros-cta-title">
            ¿Listo para trabajar con nosotros?
          </h2>
          <p className="sobre-nosotros-cta-subtitle">
            Conoce más sobre nuestros servicios y descubre cómo podemos ayudarte 
            a transformar tu empresa con tecnología.
          </p>
          <div className="sobre-nosotros-cta-buttons">
            {/* Assuming Link is from react-router-dom */}
            {/* <Link to="/contacto" className="cta-button primary">
              Agenda una consultoría
            </Link> */}
            {/* <Link to="/sectores" className="cta-button secondary">
              Ver nuestros sectores
            </Link> */}
          </div>
        </div>
      </section>
      <Footer />
    </div>
    </>
  );
};

export default SobreNosotrosPage; 